import React, { createContext, useContext, useEffect, useState } from "react";
import { api, auth } from "./api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(auth.user);

  useEffect(() => {
    if (auth.token && !user) {
      api.get("/auth/me").then((r) => setUser(r.data)).catch(() => auth.logout());
    }
    // eslint-disable-next-line
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    auth.save(data.token, data.user);
    setUser(data.user);
    return data.user;
  };

  const signup = async (email, password, name) => {
    const { data } = await api.post("/auth/signup", { email, password, name });
    auth.save(data.token, data.user);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    auth.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
